/**
 * Formats a number with commas as thousand separators.
 * @param {number} num - The number to format.
 * @returns {string} - The formatted number with commas as thousand separators.
 */
export const formatNumberWithCommas = (num: number): string =>
  num.toLocaleString("en", { maximumFractionDigits: 0 });
